import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "13 5 19 5 19 11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "11 19 5 19 5 13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "19", x2: "5", y1: "5", y2: "19", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MoveDiagonal";
const MoveDiagonal = memo(themed(Icon));
export {
  MoveDiagonal
};
//# sourceMappingURL=move-diagonal.js.map
